import { EcheancesListPage } from './EcheancesListPage';

export function APayerPage(): JSX.Element {
  return <EcheancesListPage sens="a_payer" />;
}
